<div class="panel">
  <h2>Entité</h2>

  <div class="form-group">
    <label for="name">Nom</label>
    <span id="name" class="value">{{ entity.name }}</span>
  </div>

  <div class="form-group">
    <label for="type">Type</label>
    <span id="type" class="value">{{ entity.type | slentitytype }}</span>
  </div>

  <div class="form-group" *ngIf="entity.type === 'COMPANY'">
    <label for="rcs">RCS</label>
    <span id="rcs" class="value">{{ entity.rcs | empty }}</span>
  </div>

  <div class="form-group">
    <label for="version">Version</label>
    <span id="version" class="value">{{ entity.version }}</span>
  </div>

  <div class="form-group">
    <label for="address">Adresse</label>
    <span id="address" class="value" style="white-space: pre-line;">{{ entity.address | sladdress }}</span>
  </div>

  <div class="form-group">
    <label for="email">Email</label>
    <span id="email" class="value">{{ entity.email | empty }}</span>
  </div>

  <div class="form-group">
    <label for="phone">Téléphone</label>
    <span id="phone" class="value">{{ entity.phone | empty }}</span>
  </div>
</div>